import React, { Component } from "react";
import styled from "styled-components";
import _ from "lodash";
import { Box, CircularProgress, Grid, TextField } from "@material-ui/core";
import { DebounceInput } from "react-debounce-input";
import { withAlert } from "react-alert";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import TeacherService from "../../services/TeacherService";
import Group from "../../waybee-ui/Group";
import Heading from "../../waybee-ui/Heading";
import TableGrid from "../../waybee-ui/TableGrid";
import BackButton from "../../components/BackButton";

const LoadContainer = styled.div`
  text-align: center;
  margin: 8px;
`;

class IndividualOccurrences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        name: ""
      },
      students: [],
      loading: false,
      filteredStudents: []
    };
  }

  componentDidMount() {
    this.getStudents();
  }

  getStudents = async () => {
    this.setState({ loading: true });
    try {
      const { match } = this.props;
      const studentClass =
        (match.params && match.params.id) || localStorage.getItem("class");
      const students = await TeacherService.getStudentsForClass(studentClass);
      this.setState({ students, filteredStudents: students });
    } catch (e) {
      const status = _.get(e, "response.status");
      if (status !== 403) {
        const { alert, t } = this.props;
        alert.show(t("students.errorFetch"), {
          title: t("common.actions.error")
        });
      }
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  setFilter(field, value) {
    const { filter, students } = this.state;
    this.setState({
      filter: {
        ...filter,
        [field]: value
      }
    });
    this.setState({ loading: true });
    const filteredStudents = _.filter(students, student =>
      _.includes(student.name.toLowerCase(), value.toLowerCase())
    );
    this.setState({ filteredStudents, loading: false });
  }

  redirectTo(route) {
    const { history } = this.props;
    history.push(route);
  }

  render() {
    const { filter, filteredStudents, loading } = this.state;
    const { match, t } = this.props;
    const classId = match.params.id;

    return (
      <Grid container spacing={2}>
        <BackButton to={`/classes/${classId}`} />
        <Grid item xs={12}>
          <Group>
            <Box>
              <Heading level={1} icon="group_work" gutterBottom>
                {t("individualOccurrences.title")}
              </Heading>
              <Box pb={4} pt={2}>
                <form noValidate autoComplete="off">
                  <Grid container spacing={8}>
                    <Grid item md={12}>
                      <DebounceInput
                        minLength={3}
                        debounceTimeout={400}
                        element={TextField}
                        value={filter.name}
                        onChange={e => this.setFilter("name", e.target.value)}
                        label={t("individualOccurrences.search")}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Box>
            <Box>
              {loading ? (
                <LoadContainer>
                  <CircularProgress />
                </LoadContainer>
              ) : (
                <TableGrid>
                  {filteredStudents.map(student => (
                    <TableGrid.Row
                      key={student.ra}
                      id={student.id}
                      photo={student.photo}
                      photoName={student.name}
                      actionIcon
                      button
                      onClick={() => {
                        this.redirectTo(`individualOccurrences/${student.ra}`);
                      }}
                    >
                      <TableGrid.Title xs={7}>{student.name}</TableGrid.Title>
                      <TableGrid.Text xs={5}>
                        {t("occurrences.ra", { ra: student.ra })}
                      </TableGrid.Text>
                    </TableGrid.Row>
                  ))}
                </TableGrid>
              )}
            </Box>
          </Group>
        </Grid>
      </Grid>
    );
  }
}

IndividualOccurrences.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string
    }),
    push: PropTypes.func
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  alert: PropTypes.shape({
    show: PropTypes.func
  }).isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(
  withAlert()(withRouter(IndividualOccurrences))
);
